import React from 'react';
import { Box } from '@mui/material';
import { marked } from 'marked';

const MarkdownContent = ({ content, darkMode }) => {
    if (!content) return null;

    const htmlContent = marked(content);

    return (
        <Box
            sx={{
                '& p': {
                    margin: '1px 0',
                    fontSize: '0.75rem',
                    lineHeight: '1.2',
                },
                '& strong': {
                    fontWeight: 'bold',
                },
                '& em': {
                    fontStyle: 'italic',
                },
                '& ul, & ol': {
                    margin: '1px 0',
                    paddingLeft: '8px',
                },
                '& li': {
                    margin: '0px 0',
                    fontSize: '0.75rem',
                },
                '& code': {
                    backgroundColor: darkMode ? '#333' : '#f5f5f5',
                    padding: '1px 2px',
                    borderRadius: '2px',
                    fontSize: '0.7rem',
                    fontFamily: 'monospace',
                },
                '& pre': {
                    backgroundColor: darkMode ? '#333' : '#f5f5f5',
                    padding: '2px',
                    borderRadius: '2px',
                    overflow: 'auto',
                    fontSize: '0.7rem',
                },
                '& blockquote': {
                    borderLeft: `2px solid ${darkMode ? '#2196f3' : '#1565c0'}`,
                    paddingLeft: '4px',
                    margin: '1px 0',
                    fontStyle: 'italic',
                },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                    margin: '1px 0',
                    fontWeight: 'bold',
                },
                '& h1': { fontSize: '0.9rem' },
                '& h2': { fontSize: '0.85rem' },
                '& h3': { fontSize: '0.8rem' },
                '& h4': { fontSize: '0.75rem' },
                '& h5': { fontSize: '0.7rem' },
                '& h6': { fontSize: '0.65rem' },
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};

export default MarkdownContent;

